/* unplugin-vue-components disabled */import { render } from "./GridLayout.vue?vue&type=template&id=48d37f6c&scoped=true&ts=true"
import script from "./GridLayout.vue?vue&type=script&lang=ts"
export * from "./GridLayout.vue?vue&type=script&lang=ts"

import "./GridLayout.vue?vue&type=style&index=0&id=48d37f6c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48d37f6c"]])

export default __exports__